import { createContext } from 'react';
import * as locale from 'src/configs/locale';

const LocaleConfigContext = createContext<locale.types.Config>(locale.constants.unit);

const { Provider: LocaleConfigProvider } = LocaleConfigContext;

export { LocaleConfigContext, LocaleConfigProvider };
